/**
 * File: apps/qbench-cp/reactapp/src/shared/components/FormV2/Hyperlink.js
 *
 * Purpose: Renders the hyperlink input used by FormV2 for HYPERLINK field types.
 *
 * Scope: FormV2 input rendering for hyperlink entity fields.
 *
 * Tags: customer-portal
 *
 * Overview: Exports Hyperlink, a thin wrapper that renders the shared Input component with
 *     `type="url"`, reusing Input's transform strategy unchanged for server/client value
 *     conversion.
 *
 * Exports: default Hyperlink component (with an attached `transform` static property).
 */

import React from 'react';
import Input from './Input';

/**
 * @type {import('./types').FieldTransformStrategy}
 */
const transform = {
  fromServer: Input.transform.fromServer,
  toServer: Input.transform.toServer,
  defaultValue: Input.transform.defaultValue,
};

const Hyperlink = React.memo(function Hyperlink(props) {
  return <Input type="url" {...props} />;
});

Hyperlink.transform = transform;
export default Hyperlink;
